import { useCallback } from "react";

import { chatToolCallsVar } from "@apps/ask-ai/ask-ai-context";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherChatToolCall({
  channelName,
}: {
  channelName: string;
}) {
  const handleChatToolCall = useCallback(
    ({
      chat_session_id,
      tool_name,
      result_count,
      description,
    }: {
      chat_session_id: number;
      tool_name: string;
      result_count?: number;
      description?: string;
    }) => {
      chatToolCallsVar([
        ...chatToolCallsVar(),
        {
          chatSessionId: chat_session_id,
          toolName: tool_name,
          resultCount: result_count,
          description,
        },
      ]);
    },
    [],
  );
  usePusher(channelName, "chat_tool_call", handleChatToolCall);
  return null;
}
